import React from 'react';
import { Button } from '../ui/button';
import { ArrowRight } from 'lucide-react';
import CalendlyPopup from '../CalendlyPopup';
import { useCalendlyAndVideo } from '../../hooks/useCalendlyAndVideo';

const HealthcareCTA = () => {
  const { isCalendlyOpen, openCalendly, closeCalendly } = useCalendlyAndVideo();

  return (
    <section className="py-24 px-6 relative">
      <div className="max-w-5xl mx-auto text-center">
        <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6 text-white">
          All Aboard <span className="text-cyan-400">Better Care</span>
        </h2>
        <p className="text-xl text-gray-300 mb-12 max-w-4xl mx-auto">
          Traain helps healthcare teams communicate clearly, act consistently, and deliver better experiences — one conversation at a time.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Button
            size="lg"
            onClick={openCalendly}
            className="h-14 bg-cyan-500 text-black hover:bg-cyan-400 rounded-lg px-8 text-lg font-semibold transition-all duration-200 hover:scale-105 hover:shadow-lg hover:shadow-cyan-500/50"
            data-testid="healthcare-cta-demo-btn"
          >
            See Traain for Healthcare
            <ArrowRight className="w-5 h-5 ml-2" />
          </Button>
        </div>
      </div>
      
      <CalendlyPopup isOpen={isCalendlyOpen} onClose={closeCalendly} />
    </section>
  );
};

export default HealthcareCTA;
